
import { Component, Ref, InjectReactive, Watch, Mixins } from "vue-property-decorator";
import loading from "@/mixins/loading";
import GetMerchantByRemote from "@/mixins/getMerchantByRemote";
import { Form } from "element-ui";
import UploadImg from "@/components/uploadImg.vue";
import { cloneDeep, debounce, uniqWith } from "lodash";
import { IHomeInstance } from "@/types/global";
import { getStoreListByMerchant } from "@/api/store";
import { getAllStore } from "@/api/common";

import { getMerchantDetail, saveOrUpdateMerchant, queryStore, getMerchant, getHealthExamineList, getYsbStoreList, getMerchantBuyList } from "@/api/prescriptionDb";

const initFormData = {
    id: "",
    name: "", // 品牌商名称
    stores: [], // 这里先放个 prop 给form 的rule使用
    contact: "", // 负责人
    phone: "",
    status: false,
    autoRegisterUser: false,
    allowUseQrcode: false,
    isShow: true,
    useCustomPres: 0,
    nursePres: 0,
    choiceMerchantId: "",
    defaultImgStatus: false,
    isShowImg: false,
    defaultImgUrl: [],
    remark: "", // 备注
    apiAppKey: "",
    apiAppSecret: "",
    apiStore: "",
    logoImgUrl: [],
    chineseMedicineLogo: [],
    companyName: "",
    backgroundImgUrl: [],
    appImgUrl: [],
    symptomsStatus: 0,
    healthRecordsSwitch: false,
    replaceMallSwitch: false,
    insteadMenu: "",
    insteadAddress: "",
    healthId: "",
    careId: "",
    wsUseBaseStore: 0,
    wsSymptom: 0,
    mixSySymptom: 1,
    mixYdSymptom: 1,
    symptomsForPres: 0, // 舌诊报告处方库对应症状选择：0.舌诊 1.体质
    wsAppBackImg: [],
    wsBigTitleImg: [],
    wsRatioImg: [],
    wsTopImg: [],

    wsMainLogo: [],
    wsBgImg: [],
    wsCountImg: [],
    wsTongueImg: [],
    showName: "",

    homepageMainTitle: "数智(AI)健康服务系统", // 首页主标题
    homepageSubTitle: "DIGITAL INTELLIGENCE (AI) HEALTH SERVICE SYSTEM", // 首页副标题
    homePageType: "", // 首页类型

    tongueApiQps: undefined,
    withDrawStoreId: "",
}

@Component({
    components: {
        UploadImg
    }
})
export default class merchantEdit extends Mixins(loading) {
    @Ref("validateForm") readonly validateFormRef !: Form;
    @InjectReactive() HomeInstance !: IHomeInstance;

    merchantId = this.$route.query.merchantId || "";;
    brandName = this.$route.query.brandName || "";
    title = "编辑";

    storeInfo = []; // 关联门店数据
    saveLoading = false;
    storeSelectLoading = false;
    allStoreList = [];
    nursePresList = [];
    apiStoreList = [];
    brandAccountStoreList = []; // 品牌分账门店列表

    allMerchantOptions = []; // 把所有的品牌方列表cu存储一份c    
    merchantOptions = []; // 品牌方列表
    userLoading = false;

    healthExamineList = [];

    customPresOptions = [
        { label: "默认处方库", value: 0 },
        { label: "自定义处方库", value: 1 },
        { label: "引用其他品牌处方库", value: 2 },
        { label: "关闭处方库", value: 3 },
    ];

    merchantStoreSelectLoading = false;
    allMerchantStoreList = [];

    formData = {
        id: "",
        name: "", // 品牌商名称
        stores: [], // 这里先放个 prop 给form 的rule使用
        contact: "", // 负责人
        phone: "",
        status: false,
        autoRegisterUser: false,
        allowUseQrcode: false,
        isShow: true,
        useCustomPres: 0,
        nursePres: 0,
        choiceMerchantId: "",
        defaultImgStatus: false,
        isShowImg: false,
        defaultImgUrl: [],
        remark: "", // 备注
        apiAppKey: "",
        apiAppSecret: "",
        apiStore: "",
        logoImgUrl: [],
        chineseMedicineLogo: [],
        companyName: "",
        backgroundImgUrl: [],
        appImgUrl: [],
        symptomsStatus: 0,
        healthRecordsSwitch: false,
        replaceMallSwitch: false,
        insteadMenu: "",
        insteadAddress: "",
        bookStatus: false,
        healthId: "",
        careId: "",
        wsUseBaseStore: 0,
        wsBaseStoreId: "",
        wsSymptom: 0,
        mixSySymptom: 1,
        mixYdSymptom: 1,
        symptomsForPres: 0,
        usedMerchantList: [],
        homepageMainTitle: "数智(AI)健康服务系统", // 首页主标题
        homepageSubTitle: "DIGITAL INTELLIGENCE (AI) HEALTH SERVICE SYSTEM", // 首页副标题
        homePageType: "", // 首页类型
        wsAppBackImg: [],
        wsBigTitleImg: [],
        wsRatioImg: [],
        wsTopImg: [],

        wsMainLogo: [],
        wsBgImg: [],
        wsCountImg: [],
        wsTongueImg: [],

        showName: "",
        tongueApiQps: undefined,
        withDrawStoreId: ""
    };

    baseFormRules = {
        name: [{ required: true, message: "请输入品牌方名称", trigger: "blur" }],
        homepageMainTitle: [{ required: true, message: "请输入首页主标题", trigger: "blur" }],
        // homepageSubTitle: [{ required: true, message: "请输入首页副标题", trigger: "blur" }],
        homePageType: [{ required: true, message: "请选择首页类型", trigger: "change", validator: this.validateHomepageType }],
        useCustomPres: [{ required: true, message: "请选择使用处方库", trigger: "change" }],
        choiceMerchantId: [{ required: true, message: "请选择品牌方", trigger: "change" }],
        nursePres: [{ required: true, message: "请选择调养方案处方库", trigger: "change" }],
        wsSymptom: [{ required: true, message: "请选择小程序舌诊", trigger: "change" }],
        symptomsForPres: [{ required: true, message: "请选择舌诊处方库", trigger: "change" }],
        mixSySymptom: [{ required: true, message: "请选择膳养体测舌诊", trigger: "change" }],
        mixYdSymptom: [{ required: true, message: "请选择运动体测舌诊", trigger: "change" }]
    };

    shopRules = {
        insteadMenu: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
        insteadAddress: [{ required: true, message: "请输入菜单跳转地址", trigger: "blur" }]
    }

    tongueRules = {
        wsBaseStoreId: [{ required: true, message: "请选择产品基准门店", trigger: "change" }]
    }

    get formRules() {
        return {
            ...this.baseFormRules,
            ...(this.formData.replaceMallSwitch ? this.shopRules : {}),
            ...(this.formData.wsUseBaseStore ? this.tongueRules : {})
        }
    }

    validateHomepageType(rule, value, callback) {
        callback();
    }

    replaceMallSwitchChange($event) {
        if (!$event) {
            this.formData.insteadMenu = "";
            this.formData.insteadAddress = "";
        }
    }

    validateStoreInfo(rule, value, callback) {
        if (this.storeInfo?.length) return callback();
        return callback(new Error("请选择关联门店"))
    };

    mounted() {
        this.getMerchantDetail();
        this.getMerchantList("");
        this.getHealthExamineList("");
        this.getMerchantStoreList("");
        this.getNursePresList("");
        this.getApiStoreList("");
    }

    getHealthExamineList(str) {
        if (typeof str == "object") {
            str = "";
        }
        getHealthExamineList({ examName: str }).then((res) => { 
            this.healthExamineList = res.data;
        });
    }

    getMerchantListRemote = debounce(function(merchantName) {
        this.userLoading = true;
        getMerchant({ merchantId: this.merchantId, name: merchantName }).then((res) => {
            this.userLoading = false;
            this.merchantOptions = res.data;
            if (merchantName == "") {
                this.allMerchantOptions = res.data;
            } 
        }).catch((err) => { this.userLoading = false; });
    })

    getMerchantList(str) {
        if (typeof str == "object") {
          str = "";
        }
        this.getMerchantListRemote(str)
    }

    getNursePresListRemote = debounce(function (str) {
        this.userLoading = true;
        getMerchant({ name: str }).then((res) => {
          this.userLoading = false;
          this.merchantOptions = res.data;
          this.nursePresList = [ { id: 0, name: "默认处方库"  }, ...res.data ];
        }).catch((err) => { this.userLoading = false; });
    })

    getNursePresList(str) {
        if (typeof str == "object") {
          str = "";
        }
        this.getNursePresListRemote(str);
    }

    getMerchantStoreRemote = debounce(function (str) {
        this.merchantStoreSelectLoading = true;
        getStoreListByMerchant({merchantId: this.merchantId, name: str}).then((res) => {
          this.merchantStoreSelectLoading = false;
          this.allMerchantStoreList = res.data;
        }).catch((err) => {}).finally(() => {
            this.merchantStoreSelectLoading = false;
        });
    })

    getMerchantStoreList(str) {
        if (typeof str == "object") {
          str = "";
        }
        this.getMerchantStoreRemote(str)
    }

    getApiStoreListRemote = debounce(function (str) {
        getAllStore({ storeName: str }).then((res) => {
          this.apiStoreList = res.data;
        }).catch((err) => {}).finally(() => {
        });
    })

    getApiStoreList(str) {
        if (typeof str == "object") {
          str = "";
        }
        this.getApiStoreListRemote(str)
    }

    // 品牌分账门店列表
    getBrandAccountStoreListRemote = debounce(function (str) {
        getMerchantBuyList({ merchantId: this.merchantId || 0 }).then((res) => {
          this.brandAccountStoreList = res.data;
        }).catch((err) => {}).finally(() => {
        });
    })

    getBrandAccountStoreList(str) {
        if (typeof str == "object") {
          str = "";
        }
        this.getBrandAccountStoreListRemote(str)
    }

    getMerchantDetail() {
        if (!this.merchantId) {
            this.title = "新增";
            return;
        }
        getMerchantDetail(this.merchantId).then((res) => {
            const { stores, status, autoRegisterUser, allowUseQrcode, isShow, defaultImgStatus, isShowImg, healthRecordsSwitch, replaceMallSwitch, bookStatus, wsBaseStoreId, usedMerchantList, tongueApiQps, withDrawStoreId } = res.data;
            Object.assign(this.formData, { ...res.data, status: Boolean(status), autoRegisterUser: Boolean(autoRegisterUser), allowUseQrcode: Boolean(allowUseQrcode), isShow: Boolean(isShow), defaultImgStatus: Boolean(defaultImgStatus),
                isShowImg: Boolean(isShowImg), healthRecordsSwitch: Boolean(healthRecordsSwitch), replaceMallSwitch: Boolean(replaceMallSwitch), bookStatus: Boolean(bookStatus), wsBaseStoreId: wsBaseStoreId || "",
                usedMerchantList: usedMerchantList?.map((el:any) => el.id) || [], tongueApiQps: tongueApiQps ?? undefined,
                homePageType: res.data.homePageType ?? ""
            });

            this.storeInfo = cloneDeep(stores)?.map((row) => ({ id: row.storeId, storeName: row.storeName }));
            // 如果有分账门店ID，先加载门店列表用于回显
            if (withDrawStoreId) {
                this.getBrandAccountStoreListRemote("");
            }
        })
    }

    getStoreRemote = debounce(function (str) {
        this.storeSelectLoading = true;
        queryStore({ storeId: str, storeName: str, pageNum: 1, pageSize: 500 }).then((res) => {
            this.storeSelectLoading = false;
            this.allStoreList = res.data;
        }).catch((err) => { });
    })

    getStoreList(str) {
        if (typeof str == "object") {
            str = "";
        }
        getYsbStoreList({
            keyWord: str,
            pageNum: 1,
            pageSize: 1000,
        })
        .then((res) => {
            this.allStoreList = res.data.list;
        })
        .catch((err) => {});
    }

    setCurUser(cur, key) {
        this[key].push({ ...cur, userId: cur.id });
        const comparator = (obj1, obj2) => obj1.id === obj2.id;
        this[key] = uniqWith(this[key], comparator)
    }

    handleClose(cur, key) {
        this[key] = this[key].filter((item) => {
            return item.id != cur.id;
        });
    }

    dialogClose() {
        this.storeInfo = []; // 关联门店数据
        this.formData = cloneDeep(initFormData);
        this.validateFormRef.resetFields();
        this.HomeInstance.tabRemove("merchantEdit");
    }

    dialogConfirm() {
        if (this.formData.defaultImgStatus && this.formData.defaultImgUrl.length == 0) {
            this.$message.error("请上传默认头像");
            return;
        }
        // 判断百症调养是否为使用品牌方内容
        if (this.formData.symptomsStatus == 1) {
            this.$confirm(`使用品牌方内容将不展示养身帮的内容，请尽快在品牌方的【百症调养配置】内进行对应内容配置。`, "提示", {
                showCancelButton: false,
                confirmButtonText: "我已知晓",
                type: "warning",
            }).then(() => {
                this.confirmCall();
            });
            return;
        }
        this.confirmCall();

    }

    getUsedMerchantList() {
        const totalMap = _.keyBy(this.allMerchantOptions, 'id');
        const result = this.formData.usedMerchantList.map(id => totalMap[id]).filter(Boolean)
        return result;
    }

    confirmCall() {
        this.validateFormRef.validate().then(() => {
            console.log(this.formData)
            const params = {
                ...this.formData,
                stores: cloneDeep(this.storeInfo)?.map((row) => ({ storeId: row.id, storeName: row.storeName })),
                status: Number(this.formData.status),
                autoRegisterUser: Number(this.formData.autoRegisterUser),
                allowUseQrcode: Number(this.formData.allowUseQrcode),
                isShow: Number(this.formData.isShow),
                choiceMerchantId: this.formData.useCustomPres == 2 ? this.formData.choiceMerchantId : "",
                defaultImgStatus: Number(this.formData.defaultImgStatus),
                isShowImg: Number(this.formData.isShowImg),
                defaultImgUrl: this.formData.defaultImgUrl[0]?.url || "",
                logoImgUrl: this.formData.logoImgUrl[0]?.url || "",
                chineseMedicineLogo: this.formData.chineseMedicineLogo[0]?.url || "",
                backgroundImgUrl: this.formData.backgroundImgUrl[0]?.url || "",
                appImgUrl: this.formData.appImgUrl[0]?.url || "",
                healthRecordsSwitch: Number(this.formData.healthRecordsSwitch),
                replaceMallSwitch: Number(this.formData.replaceMallSwitch),
                insteadMenu: this.formData.replaceMallSwitch ? this.formData.insteadMenu : "",
                insteadAddress: this.formData.replaceMallSwitch ? this.formData.insteadAddress : "",
                bookStatus: Number(this.formData.bookStatus),
                wsUseBaseStore: Number(this.formData.wsUseBaseStore),
                wsSymptom: Number(this.formData.wsSymptom),
                mixSySymptom: Number(this.formData.mixSySymptom),
                mixYdSymptom: Number(this.formData.mixYdSymptom),
                symptomsForPres: Number(this.formData.symptomsForPres),
                usedMerchantList: this.getUsedMerchantList(),
                wsAppBackImg: this.formData.wsAppBackImg[0]?.url || "",
                wsBigTitleImg: this.formData.wsBigTitleImg[0]?.url || "",
                wsRatioImg: this.formData.wsRatioImg[0]?.url || "",
                wsTopImg: this.formData.wsTopImg[0]?.url || "",

                wsMainLogo: this.formData.wsMainLogo[0]?.url || "",
                wsBgImg: this.formData.wsBgImg[0]?.url || "",
                wsCountImg: this.formData.wsCountImg[0]?.url || "",
                wsTongueImg: this.formData.wsTongueImg[0]?.url || "",

                tongueApiQps: this.formData.tongueApiQps ?? null,
            }
            console.log(params)
            this.saveLoading = true;
            saveOrUpdateMerchant(params).then(() => {
                this.dialogClose();
                this.$message.success("保存成功");
            }).finally(() => {
                this.saveLoading = false;
            })
        });
    }

    @Watch('storeInfo')
    validateField(val, oldVal) {
        this.validateFormRef.validateField(["storeInfo"])
    }
}
